<template>
  <div class="container mx-auto my-8">
    <base-form v-if="subject" :do="save" :v-errors="error" class="flex flex-wrap flex-col-reverse md:flex-row md:-mx-4">
      <!-- TAB COMPONENT -->
      <base-tabs class="w-full md:w-2/3 md:px-4">
        <base-tab name="Inventarisatie" class="flex content" :selected="true">
          <tab-order :subject="subject" :has-permission="isUpdateAllowed" />
        </base-tab>
        <base-tab name="Sanering" class="flex content">
          <tab-documents :order="order" :has-permission="isUpdateAllowed"/>
        </base-tab>
      </base-tabs>
      <!-- GENERAL INFORMATION -->
      <div class="flex flex-col w-full md:w-1/3 px-4">
        <div class="buttons flex justify-end mb-4" v-if="isUpdateAllowed">
          <button type="submit" class="btn btn-sm bg-green-dark">Opslaan</button>
        </div>
        <!-- CONTACT -->
        <div class="w-full mb-4 shadow" style="background-color: #e7eef3;" v-if="inventory">
          <div class="field w-full px-4 pt-4 pb-2">
            <div class="heading mb-2">
              <label class="flex justify-between uppercase tracking-wide text-xs text-grey-dark font-bold" for="">
                <span>Opdrachtgever</span>
                <font-awesome-icon v-if="isUpdateAllowed" :icon="['far', 'edit']" class="icon cursor-pointer" @click="clientEditable = !clientEditable" />
              </label>
              <!-- <label class="uppercase tracking-wide text-xs text-grey-dark font-bold" for="">Opdrachtgever</label> -->
            </div>
            <div class="input">
              <span class="block w-full text-sm" v-if="!clientEditable">
                {{ inventory.order ? inventory.order.client.name : '-' }}
              </span>
              <div class="relative" v-if="clientEditable">
                <autocomplete-input
                  css="padding-right: 77px;"
                  name="owner"
                  v-model="client"
                  :items="clientNames"
                  :isAsync="true"
                  @changed="onClientChanged"
                ></autocomplete-input>
                <button type="button" class="absolute z-10 pin-r pin-y text-grey-dark text-xs flex items-center" style="font-size: .6rem;">
                  <span @click="saveClient()" class="ml-2 px-2 py-1 h-full border-l-2 font-semibold tracking-wide uppercase">Opslaan</span>
                </button>
              </div>

              <!-- <span class="block w-full text-sm">{{ inventory.order.client.name }}</span> -->
            </div>
          </div>
          <div class="field w-full px-4 py-2 pt-2">
            <div class="heading mb-2">
              <label class="uppercase tracking-wide text-xs text-grey-dark font-bold" for="">Contactpersoon</label>
            </div>
            <div class="input">
              <span class="block w-full text-sm">{{ inventory.order.contact }}</span>
            </div>
          </div>
          <div class="field w-full px-4 py-2 pt-2 pb-4">
            <div class="heading mb-2">
              <label class="flex justify-between uppercase tracking-wide text-xs text-grey-dark font-bold" for="">
                <span>Eigenaar</span>
                <font-awesome-icon v-if="isUpdateAllowed" :icon="['far', 'edit']" class="icon cursor-pointer" @click="editable = !editable" />
              </label>
            </div>
            <div class="input">
              <span class="block w-full text-sm" v-if="!editable">
                {{ subject.owner ? subject.owner.contact.name : '-' }}
              </span>
              <div class="relative" v-if="editable">
                <autocomplete-input
                  css="padding-right: 77px;"
                  name="owner"
                  v-model="contact"
                  :items="contactNames"
                  :isAsync="true"
                  @changed="onOwnerChanged"
                ></autocomplete-input>
                <button type="button" class="absolute z-10 pin-r pin-y text-grey-dark text-xs flex items-center" style="font-size: .6rem;">
                  <span @click="saveOwner()" class="ml-2 px-2 py-1 h-full border-l-2 font-semibold tracking-wide uppercase">Opslaan</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- ADDRESS -->
        <div class="general w-full bg-white mb-4 shadow">
          <field-sidebar label="Straat" :is-allowed="isUpdateAllowed" :value="subject.street">
            <input class="text w-full" type="text" name="street" id="Straat" placeholder="Voer een straat in" v-model="subject.street" />
          </field-sidebar>
          <field-sidebar label="Nummer" :is-allowed="isUpdateAllowed" :value="subject.house_number">
            <input class="text w-full" type="text" name="house_number" id="Nummer" placeholder="Voer een nummer in" v-model="subject.house_number" />
          </field-sidebar>
          <field-sidebar label="Postcode" :is-allowed="isUpdateAllowed" :value="subject.postal_code">
            <input class="text w-full" type="text" name="postal_code" id="Postcode" placeholder="Voer een postcode in" v-model="subject.postal_code" />
          </field-sidebar>
          <field-sidebar label="Plaats" :is-allowed="isUpdateAllowed" :value="subject.city">
            <input class="text w-full" type="text" name="city" id="Plaats" placeholder="Voer een plaats in" v-model="subject.city" />
          </field-sidebar>
          <field-sidebar label="Complex" :is-allowed="true" :value="complex">
            <div class="relative">
              <select id="sanmer" v-model="complex" :disabled="!isUpdateAllowed" :class="{ 'cursor-pointer': isUpdateAllowed }" class="w-full appearance-none select pr-6 text-black">
                <option value="" class="text-grey">Selecteer...</option>
                <option v-for="item in complexes" :key="item.id" :value="item.id">
                  {{ item.name }}
                </option>
              </select>
              <div v-if="isUpdateAllowed" class="pointer-events-none absolute pin-y pin-r flex items-center px-2 text-grey-darker">
                <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
              </div>
            </div>
          </field-sidebar>
          <field-sidebar label="Pandnr" name="pandnummer" :is-allowed="isUpdateAllowed" :value="subject.pand_nr">
            <input class="text w-full" type="text" name="pandnummer" id="Pandnr" placeholder="Voer een pandnummer in" v-model="subject.pand_nr" />
          </field-sidebar>
        </div>
        <!-- DOCUMENTS -->
        <file-viewer class="mb-4"
          type="map"
          empty-text="Plattegrond toevoegen"
          :file="map"
          @click="openDocumentModal"
          @remove="deleteFile">
        </file-viewer>
        <file-viewer
          type="assessment-report"
          empty-text="Inventarisatie toevoegen"
          :file="report"
          @click="openDocumentModal"
          @remove="deleteFile">
        </file-viewer>
      </div>
    </base-form>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import ApiService from '@/common/api.service';
import ContactService from '@/services/contact';
import BaseForm from '@/components/globals/BaseForm';
import FileViewer from '@/components/globals/FileViewer';
import FieldSidebar from '@/components/globals/FieldSidebar';
import SearchSelect from '@/components/globals/SearchSelect';

import Complex from '@/store/modules/complex';
import SubjectService from '@/services/subject';
import SubjectPerimeter from '@/perimeters/subject';

import TabOrder from '@/components/tabs/TabOrder';
import TabDocuments from '@/components/tabs/TabDocuments';

import AutocompleteInput from '@/components/inputs/Autocomplete';

import { mapState } from 'vuex';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  name: 'SubjectEdit',
  perimeters: [SubjectPerimeter],
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    BaseForm,
    Datepicker,
    FileViewer,
    FieldSidebar,
    SearchSelect,
    TabOrder,
    TabDocuments,
    AutocompleteInput,
    FontAwesomeIcon
  },
  data() {
    return {
      isChanged: false,
      isSaving: false,
      isNew: false,
      date: new Date(),
      subject: null,
      source: null,
      complexes: null,
      contacts: [],
      contactNames: [],
      contact: null,
      retry: true,
      editable: false,
      clients: [],
      clientNames: [],
      client: [],
      retryClient: true,
      clientEditable: false
    };
  },
  created() {
    this.fetch();
    this.fetchComplexes();
  },
  beforeRouteLeave(to, from, next) {
    if (!this.changed) return next();

    const answer = window.confirm(
      'Wijzigingen die je hebt aangebracht, worden mogelijk niet opgeslagen.'
    );

    if (!answer) return next(false);

    return next();
  },
  watch: {
    $route: 'fetch'
  },
  computed: {
    ...mapState('subject', ['error']),
    ...mapState('modal', ['items']),
    inventory() {
      return this.subject.inventories[this.subject.inventories.length - 1];
    },
    order() {
      return this.subject.inventories[this.subject.inventories.length - 1]
        .order;
    },
    isUpdateAllowed() {
      return this.$isAllowed('update');
    },
    map() {
      let map = this.subject.map;
      if (this.items && this.items.files && this.items.type == 'map') {
        map = this.items.files[0];
        this.$store.commit('modal/setItems', null);
      }
      return map;
    },
    report() {
      let report = this.order.assessment_report;
      if (
        this.items &&
        this.items.files &&
        this.items.type == 'assessment-report'
      ) {
        report = this.items.files[0];
        this.$store.commit('modal/setItems', null);
      }
      return report;
    },
    complex: {
      get() {
        return this.subject !== null ? this.subject.parent_id : '';
      },
      set(newValue) {
        this.subject.parent_id = newValue;
      }
    }
  },
  methods: {
    selectboxChanged(option) {
      this.subject.parent_id = option ? option.id : null;
    },
    formatter(date) {
      return this.$moment(date).format('DD-MM-YYYY');
    },
    update() {
      this.isChanged = true;
    },
    openDocumentModal(type) {
      this.$store.commit('modal/setItems', {
        id: this.order.id,
        type: type,
        subjectId: this.subject.id
      });
      this.$store.commit('modal/show', 'DocumentModal');
    },
    async onClientChanged(value) {
      if (value.length < 3) return (this.retryClient = true);

      if (!this.clientNames.length && !this.retryClient)
        return (this.clientNames = []);

      const { data: response } = await ContactService.search(value);

      this.clients = response.data;
      this.clientNames = response.data.map(client => {
        return client.name;
      });

      if (!this.clientNames.length) {
        this.retryClient = false;
      }
    },
    async saveClient() {
      if (!this.clients.length) return alert('Selecteer een opdrachtgever');

      const client = this.clients.find(client => {
        return this.client == client.name;
      });

      const { data: response } = await SubjectService.client(
        this.order.id,
        client.id
      ).catch(err => console.log(err));

      this.clientEditable = false;
      this.subject.inventories[0].order.client = response.data;
      this.contacts = [];
    },
    async onOwnerChanged(value) {
      if (value.length < 3) return (this.retry = true);

      if (!this.contactNames.length && !this.retry)
        return (this.contactNames = []);

      const { data: response } = await ContactService.search(value);

      this.contacts = response.data;
      this.contactNames = response.data.map(contact => {
        return contact.name;
      });

      if (!this.contactNames.length) {
        this.retry = false;
      }
    },
    async saveOwner() {
      if (!this.contacts.length) return alert('Selecteer een eigenaar');

      const owner = this.contacts.find(contact => {
        return this.contact == contact.name;
      });

      const { data: response } = await SubjectService.owner(
        this.subject.id,
        owner.id
      ).catch(err => console.log(err));

      this.editable = false;
      this.subject.owner = response.data.owner;
      this.contacts = [];
    },
    async deleteFile(response) {
      let url = `/v1/files/${response.file.id}`;
      let type = response.type == 'map' ? 'map' : 'assessment_report';

      if (type == 'map' && this.subject.map_location != 'project') {
        url = `v1/subjects/${this.subject.id}/map`;
      }

      await ApiService.delete(url);
      this.$store.commit('modal/setItems', null);

      if (type == 'map') {
        return (this.subject.map = null);
      }
      this.order[type] = null;
    },
    async fetchComplexes() {
      if (!this.$store.state.complex) {
        await this.$store.registerModule('complex', Complex);
      }

      this.$store.commit('complex/setFilters', { key: 'limit', value: 1000 });
      await this.$store.dispatch('complex/fetchAll');

      this.complexes = this.$store.state.complex.items;
    },
    async fetch() {
      if (!this.$route.params.id) {
        this.subject = { type: 'residence' };
        return (this.isNew = true);
      }

      try {
        // get data object and rename it to response
        const { data: response } = await SubjectService.get(
          this.$route.params.id
        );
        this.subject = response.data;
      } catch (error) {
        this.$store.commit('subject/setError', error);
        this.subject = null;
      }
    },
    async save() {
      await this.$store.dispatch('subject/save', this.subject);

      if (this.error) {
        return this.addErrors(this.error);
      }
      return this.$router.push({ name: 'home' });
    },
    addErrors(errors) {
      for (let key in errors.details) {
        if (!errors.details.hasOwnProperty(key)) continue;

        const field = this.$validator.fields.find({
          name: key,
          scope: this.$options.scope
        });

        if (!field) continue;

        this.$validator.errors.add({
          id: field.id,
          field: key,
          msg: errors.details[key][0],
          scope: this.$options.scope
        });

        field.setFlags({
          invalid: true,
          valid: false,
          validated: true
        });
      }
    }
  }
};
</script>
